import { useTypedQuery } from "hooks";
import { LocationsOverviewDashboardQueryKeys } from "modules/LocationOverviewDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useLanguagesQuery = () =>
  useTypedQuery({
    queryKey: LocationsOverviewDashboardQueryKeys.languages,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data?.languages ?? [],
    select: languages => languages.map(({ language_code }) => ({ key: language_code, value: language_code, text: language_code }))
  });
